module.exports = __webpack_public_path__ + "static/media/back-android.20acf9ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/back-android.svg
// module id = 140
// module chunks = 0